import React, { useEffect, useState } from 'react'
import './App.scss';
import { Link } from 'react-scroll';
import GoogleMapReact from 'google-map-react'
import Navbar from './components/Navigation/Navbar';
import ship from './assets/ship-small.mp4'
import aboutBnw from './assets/about-bnw.jpg'
import aboutSec2 from './assets/about-sec2.jpg'
import warehouse from './assets/warehouse.jpg'
import office from './assets/office.jpg'
import office2 from './assets/office2.jpg'
import office3 from './assets/office3.jpg'
import RightNav from './components/Navigation/RightNav';

import ReactGA from "react-ga4";

// Initialize ReactGA with your Measurement ID
ReactGA.initialize('G-PBE5D5K9N2');


const location = {
  address: '1600 Amphitheatre Parkway, Mountain View, california.',
  lat: 35.69470,
  lng: 139.76647,
}
const LocationPin = ({ text }) => (
  <div>
    <div className="marker">
      <div className="pin"></div>
      <div className="pin-effect"></div>
    </div>
    <p className="pin-text">{text}</p>
  </div>
)

function App() {

  useEffect(() => {
    ReactGA.send({
      hitType: "Pageview",
      page: window.location.pathname + window.location.search,
      title: "Home Page",
    })
  }, []);

  // Retrieve the language from local storage or use a default value
  const savedLanguage = localStorage.getItem('language') || 'en';
  const [currentLanguage, setCurrentLanguage] = useState(savedLanguage);

  // Listen for changes to the 'language' key in local storage
  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage && storedLanguage !== currentLanguage) {
      setCurrentLanguage(storedLanguage);
    }
  }, [currentLanguage]);

  const setLang = (lang) => {
    // Set the language in local storage
    localStorage.setItem('language', lang);
    setCurrentLanguage(lang);
  };

  const langToggler = () => {
    currentLanguage === 'en' ? setLang('jp') : setLang('en');
  };

  console.log("App.js - currentLanguage:", currentLanguage);

  // You can now use the currentLanguage in your translations or components
  const translations = require(`./translations/${currentLanguage}.json`);
  


  return (
    <div className="App">
      <Navbar></Navbar>
      <div className='goto-bot'>
        <span>
        <Link 
          to="home"
          smooth={true}
          offset={-70}>
          <button>➞</button>
        </Link>
        </span>
      </div>

      <video className='banner' autoPlay loop muted playsInline>
        <source src={ship} type='video/mp4' />
      </video>

      <section className="home" id="home">
        <div className="wrapper">
          <div className="company">
            <div className="company-name-container">
              <span className="company-name">{translations.onesforteEn}</span>
              <span className="company-name jap">{translations.onesforteJap}</span>
              <span className="company-motto">Ship Spare Parts Supply</span> 
              <div className="call-to-action">
                <Link 
                to="about"
                smooth={true}
                offset={-70}>
                  <button>{translations.about}</button>
                </Link>
                <Link 
                to="products"
                smooth={true}
                offset={-70}>
                  <button>{translations.products}</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about" id="about">
        <div className="wrapper">
          <div className="title tile-about">
            <span>{translations.about}</span>
          </div>
          {/* <div className="about-content">
            <span>
              Timely supply of <strong>High Quality</strong> parts at reasonable price. One's Forte's attitude does not change even for <strong>small parts</strong>.
            </span>
          </div> */}
          <div className="about-more">
            {/* <article>
              One's Forte is making utmost efforts to supply up-to-date equipment and a large variety of machinery, parts and tools quickly and reliably at reasonable price. To precisely meet the demands from domestic and overseas users, the company is dealing with a greater variety of items and expanding the capability through which streamlined services can be offered for any type of products ranging from small parts to main engines and ships. We know that resolving these issues is the key to creating a better future for humanity.
            </article> */}

            <div className="about-grid">
              <div className='about-content'>
                <span className='subtitle'>{translations.aboutTitle1}</span>
                <article className='art1'>
                {translations.aboutContent1}
                </article>
                <span className='subtitle'>{translations.aboutTitle2}</span>
                <article>
                {translations.aboutContent2}
                </article>
              </div>
              <div className="about-image">
                <img src={aboutBnw} alt="ship" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="history">
        <div className="wrapper">
          <div className="grid-history">
            <div>
              <span className="title-history">{translations.date}</span>
              <span className="subtitle-history">{translations.dateEstablished}</span>
            </div>
            <div className="vr"></div>
            <div>
              <span className="title-history">{translations.tokyo}</span>
              <span className="subtitle-history">{translations.location}</span>
            </div>
            <div className="vr"></div>
            <div>
              <span className="title-history">{translations.hiroshi}</span>
              <span className="subtitle-history">{translations.managing}</span>
            </div>
            {/* <div className="vr"></div>
            <div>
              <span className="title-history">Mizuho Bank, Ltd.</span>
              <span className="subtitle-history">Bank (Kanda Branch)</span>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section className='bank'>
        <div className='wrapper'>
          <div className='bank-info'>
          <span className='bank-name'>Sumitomo Mitsui Banking Corporation Kanda Branch</span>
          <span className='bank-name'>Mizuho Bank Kanda Branch</span>
          <span className='bank-branch'>Bank</span>
          </div>
        </div>
      </section> */}

      <section className="about">
        <div className="wrapper">
          <div className="about-more">

            <div className="about-grid">
            <div className="about-image">
                <img className='img2' src={aboutSec2} alt="ship" />
              </div>
              <div className='about-content about-content2'>
                <span className='subtitle'>{translations.aboutTitle3}</span>
                <article className='art1'>
                {translations.aboutContent3}               
                </article>
                <span className='subtitle'>{translations.aboutTitle4}</span>
                <article className='art1'>
                {translations.aboutContent4}   
                </article>
                <span className='subtitle'>{translations.aboutTitle5}</span>
                <article>
                {translations.aboutContent5}   
                </article>
              </div>
              
            </div>
          </div>
        </div>
      </section>

      
      <img className='warehouse' src={warehouse} alt="ship" />
      

      <section className="about about2">
        <div className="wrapper">
          <div className="about-more">

            <div className="about-grid">
            <div className="about-image">
                {/* <img className='img2' src={aboutSec2} alt="ship" /> */}
              </div>
              <div className='about-content about-content3'>
                {/* <img className='' src={office} alt="ship" /> */}

                <div className="bgImage">
                  <div className='img-holder'></div>
                </div>

                <span className='subtitle'>{translations.aboutTitle6}</span>
                <article className='art1'>
                {translations.aboutContent6a}   
                </article>
                <article className='art1'>
                {translations.aboutContent6b}   
                </article>
                <span className='subtitle'>{translations.aboutTitle7}</span>
                <article className='art1'>
                {translations.aboutContent7}   
                </article>
                <span className='subtitle'>{translations.aboutTitle8}</span>
                <article>
                {translations.aboutContent8}   
                </article>
              </div>
              
            </div>
          </div>
        </div>
      </section>

      <section className="products" id="products">
        <div className="wrapper">
          <div className="title">
            <span>{translations.products}</span>
          </div>
          <div className="products-grid">
            <div>
              <span><strong>Diesel Engines</strong></span>
              <ul>
                <li>Akasaka Diesels Limited</li>
                <li>Daihatsu Diesel Mfg Co Ltd</li>
                <li>Diesel United Ltd</li>
                <li>Hitachi Zosen Corporation</li>
                <li>Hanshin Diesel Works Ltd</li>
                <li>Ishikawajima-harima Heavy Ind Co Ltd</li>
                <li>Kawasaki Heavy Industries Ltd</li>
                <li>Kobe Diesel Co Ltd</li>
                <li>Makita Corporation</li>
                <li>Mitsubishi Heavy Ind Co Ltd</li>
                <li>Mitsui Shipbuilding & Engineering Co Ltd</li>
                <li>NKK Corporation (JFE)</li>
                <li>Yanmar Diesel Engine Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Cranes & Hatch Covers</strong></span>
              <ul>
                <li>Fukushima Ltd</li>
                <li>Ishikawajima-harima Heavy Ind Co Ltd</li>
                <li>Kawasaki Heavy Industries Ltd</li>
                <li>MacGREGOR-Kayaba Ltd</li>
                <li>Mitsubishi Heavy Ind Co Ltd</li>
                <li>Nakata Mac Co Ltd</li>
                <li>Nippon Pusnes Co Ltd</li>
                <li>Sekigahara Seisakusho Ltd</li>
                <li>Tsuji Heavy Industries Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Pumps</strong></span>
              <ul>
                <li>Daito Kogyo Co Ltd</li>
                <li>Heishin Engineering Ltd</li>
                <li>Heishin Pump Works Co Ltd</li>
                <li>Ishii Machinery Works Co Ltd</li>
                <li>Kosaka Laboratory Ltd</li>
                <li>Naniwa pump Mfg Co Ltd</li>
                <li>Shinko Ind Ltd</li>
                <li>Taiko Kikai Ind Co Ltd</li>
                <li>Teikoku Machinery Works Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Electric Equipment</strong></span>
              <ul>
                <li>Fuji Electric Co Ltd</li>
                <li>Mitsubishi Electric Co Ltd</li>
                <li>Nishishiba Electric Co Ltd</li>
                <li>Omron Corporation</li>
                <li>Sanshin Electric Corporation</li>
                <li>Taiyo Electric Co Ltd</li>
                <li>Terasaki Electric Co Ltd</li>
                <li>Uzushio Electric Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Filters & Strainers</strong></span>
              <ul>
                <li>Ameroid Japan Service Co Ltd</li>
                <li>Fuji Filter Mfg Co Ltd</li>
                <li>Kanagawa Kiki Kogyo Co Ltd</li>
                <li>Masuda Manufacturing Co Ltd</li>
                <li>Niikura Kogyo Co Ltd</li>
                <li>Taisei Kogyo Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Boilers & Burners</strong></span>
              <ul>
                <li>Miura Co Ltd</li>
                <li>Osaka Boiler Co Ltd</li>
                <li>Sunflame Co Ltd</li>
                <li>Tortoise Engineering Co Ltd</li>
                <li>Volcano Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Air Compressors</strong></span>
              <ul>
                <li>Matsubara Iron Works Ltd</li>
                <li>Suction Gas Engine Mfg Co Ltd</li>
                <li>Tanabe Pneumatic Machinery Co Ltd</li>
                <li>Yanmar Diesel Engine Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Air Condition & Refrigeration</strong></span>
              <ul>
                <li>Daikin Industries Ltd</li>
                <li>Namirei-Showa Co Ltd</li>
                <li>Ushio Reinetsu Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Purifiers</strong></span>
              <ul>
                <li>Alfa Laval Japan Ltd</li>
                <li>Mitsubishi Kakoki Kaisha Ltd</li>
                <li>Tomoe Engineering Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Separators</strong></span>
              <ul>
                <li>Heishin Pump Works Co Ltd</li>
                <li>Sasakura Engineering Co Ltd</li>
                <li>Taiko Kikai Ind Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Valves</strong></span>
              <ul>
                <li>Keihin</li>
                <li>Nakakita Seisakusho</li>
                <li>Niikura Kogyo Co Ltd</li>
              </ul>
            </div>
            <div>
              <span><strong>Others</strong></span>
              <ul>
                <li>Meiyo Electric Co Ltd</li>
                <li>Nippon Controls Co Ltd</li>
                <li>Nunotani Hakuyo Keiki Kogyo Co Ltd</li>
                <li>Woodward Japan Ltd</li>
                <li>Zexel Co Ltd</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      

      <section className="contact" id="contact">
        {/* <div className="wrapper"> */}
          {/* <div className="wrapper"> 
            <div className="title">
              <span>Contact</span>
            </div>
          </div> */}

          <section className="contact-top">
            <div className="contact-grid">
              <div className="content content-bank">
                <div className="contact-form contact-form-top">
                  {/* <div>
                    <span className="get">Get in touch</span>
                  </div>
                  <form name="contact" method="POST" data-netlify-recaptcha="true" data-netlify="true">
                    <input type="hidden" name="form-name" value="contact" />
                    <input required type="text" name="name" placeholder="Name *" />
                    <input required type="email" name="email" placeholder="Email *" />
                    <input required type="tel" name="telephone" placeholder="Phone *" />
                    <textarea required name="message" cols="10" rows="10" placeholder="Message *"/>
                    <div className="captcha" data-netlify-recaptcha="true"></div>
                    <button type="submit">Send Message</button>
                  </form> */}
                  <span className='title'>{translations.bank}</span>
                  {/* <a href = "mailto:sales@ones-forte.jp?subject=ONE'S FORTE">
                    <button type="submit">Send Us Email</button>
                  </a> */}
                  <div className='contact-info-container'>
                    <div>
                      <span className="contact-info-title">{translations.sumimoto}</span>
                      <span>{translations.kanda}</span>
                    </div>
                    <div>
                      <span className="contact-info-title">{translations.mizuho}</span>
                      <span>{translations.kanda}</span>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div className="overlay"></div>
            </div>
          </section>

          <section className="contact-top">
            <div className="contact-grid">
              <div className="overlay"></div>
              <div className="content">
                <div className="contact-form">
                  
                  <span className='get-in-touch-en'>{translations.getInTouchEn}</span>
                  <span className='get-in-touch-jap'>{translations.getInTouchJap}</span>
                  {/* <a href = "mailto:sales@ones-forte.jp?subject=ONE'S FORTE">
                    <button type="submit">Send Us Email</button>
                  </a> */}
                  <div className='contact-info-container'>
                    <div>
                      <span className="contact-info-title">{translations.tel}</span>
                      <span>03-5283-5252</span>
                    </div>
                    <div>
                      <span className="contact-info-title">Fax</span>
                      <span>03-5283-5251</span>
                    </div>
                    <div>
                      <span className="contact-info-title">{translations.email}</span>
                      <span>sales@ones-forte.jp</span>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </section>

          <section className="contact-bottom">
            <div className="contact-grid">
              <div className="content">
                <div className="contact-info">
                  <div className="get">
                    <span>{translations.accessEn}</span>
                    <span>{translations.accessJap}</span>
                  </div>
                  <div className="contact-info-container">
                    <div>
                      <span className="contact-info-title">{translations.officeAddress}</span>
                      <span>{translations.officeAddressContent}</span>
                    </div>
                    
                    <div>
                      <span className="contact-info-title">{translations.fromStation}</span>
                      <span className="station">{translations.fromStationContent1}</span>
                      <span className="station">{translations.fromStationContent2}</span>
                      <span className="station">{translations.fromStationContent3}</span>
                      <span className="station">{translations.fromStationContent4}</span>
                      <span className="station">{translations.fromStationContent5}</span>
                      <span className="station">{translations.fromStationContent6}</span>
                      <span className="station">{translations.fromStationContent7}</span>
                    </div>
                  </div>
                  <div className="get">
                    <span>{translations.warehouse}</span>
                  </div>
                  <div className="contact-info-container">
                    <div>
                      <span className="contact-info-title">{translations.warehouseTitle1}</span>
                      <span>{translations.warehouseContent1}</span>
                    </div>
                    
                    <div className='margin-bot'>
                      <span className="contact-info-title">{translations.warehouseTitle2}</span>
                      <span>{translations.warehouseContent2}</span>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div className="overlay">
                <GoogleMapReact
                  bootstrapURLKeys={{ key: 'AIzaSyDcX2pIrYlabJ4DmM8Y7IawE0tP2SOTHOI' }}
                  defaultCenter={location}
                  defaultZoom={15}>
                  <LocationPin
                    lat={location.lat}
                    lng={location.lng}
                    // text={location.address}
                  />
                </GoogleMapReact>
              </div>
            </div>
          </section>

        {/* </div> */}
      </section>

      {/* <section className="google-map">
        <div className="map-wrapper">
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyDcX2pIrYlabJ4DmM8Y7IawE0tP2SOTHOI' }}
          defaultCenter={location}
          defaultZoom={15}
        >
        <LocationPin
          lat={location.lat}
          lng={location.lng}
          // text={location.address}
        />
        </GoogleMapReact>
        </div>
      </section> */}

      <section className="footer">
        <div className="wrapper">
            <div className="grid-footer">
              <div className="footer-left">
                <span>© 2023 One's Forte Co., LTD</span>
                <span>Site developed by 
                  <a target="_blank" rel="noopener noreferrer" href="https://design.jinsgonzales.com"> Jins Gonzales Design</a>
                </span>
              </div>
            </div>
        </div>
      </section>

    </div>
  );
}

export default App;
